<div *ngIf="isBigBlueButtom" id="box" [style.height.px]="scrHeight" [ngClass]="[bntStyle]" style="transition: all 500ms cubic-bezier(0.25, 0.25, 0.75, 0.75);" class="">
  <div class="header">
      <!-- <button (click)="submit('left')">LEFT</button>
      <button (click)="submit('width')">height</button>
      <button (click)="submit('opacity')">opacity</button> -->
      <div [ngClass]="[headerStyle]">
          <button type="button" aria-label="Close" class="close pull-right" (click)="closeVirtual()"
          style="top: 1px;width: 30px;">
          <span aria-hidden="true" style="font-size: 21px;"><i class="uil uil-times"></i></span>
      </button>
      <button *ngIf="bntStyle == 'left'" type="button" aria-label="Close" class="close pull-right" (click)="submit('width','float-right')"
          style="top: 1px;width: 30px;">
          <span aria-hidden="true" style="font-size: 17px;"><i class="uil uil-browser"></i></span>
      </button>
      <button *ngIf="bntStyle == 'width'" type="button" aria-label="Close" class="close pull-right" (click)="submit('left','float-left')"
          style="top: 1px;width: 30px;">
          <span aria-hidden="true" style="font-size: 17px;"><i class="uil uil-minus"></i></span>
      </button>
      </div>
      
      
      
  </div>
  <iframe id="iframe_page" type="text/html" [src]="urlVirtual" allow="camera *;microphone *" frameborder="0" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" 
      style="overflow:auto; border: 1px ridge #fdfeff; width: 100%; height: 100%;">
  </iframe>
</div>